import axios from "axios";
import {authHeader, jsonAuthHeader} from "./auth-header";
import {COMPUTING_SUPER_ADMIN_API_URL} from "../containers/canopia/CanopiaUtils";

class SuperAdminService {

    async loadCronConfigs() {
        return axios.get(COMPUTING_SUPER_ADMIN_API_URL + "cron-configs",
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            })
    }

    async saveCronConfig(alias, cron) {
        const formData = new FormData();
        formData.append(
            "alias", alias
        );
        formData.append(
            "cron", cron
        );
        return axios.post(COMPUTING_SUPER_ADMIN_API_URL + "update-cron-config",
            formData,
            {
                headers: authHeader(),
                cache: 'no-store'
            })
    }
}

const superAdminService = new SuperAdminService();
export default superAdminService;
